export type SponsorshipIndicators = {
  affiliates: number
  clicks: number
  convertionRate: number
  earnings: number
}

export type SourceData = {
  clicks: number
  domain: string
}

export type EvolutionData = {
  date: Date
  value: number
}

export type EvolutionsData = {
  affiliates: EvolutionData[]
  clicks: EvolutionData[]
  earnings: EvolutionData[]
}

export const initialIndicators : SponsorshipIndicators = {
  affiliates: 0,
  clicks: 0,
  convertionRate: 0,
  earnings: 0
}
